// React
import * as React from 'react';

// Router
import { Route, Switch } from 'react-router-dom';

// Route Components
import KPITrackerPage from 'containers/KPITrackerPage';

export default (props) => <KPITrackerPage />;



// WEBPACK FOOTER //
// ./src/js/routes/SpecialRoutes.jsx